import * as types from './actionTypes';  
import offeringUserInfoApi from '../api/offeringUserInfoApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';

export function doOfferingUserInfo(userId) {

  return {
    type: types.DO_OFFERING_USER_INFO, 
    userId
  };
}

export function doOfferingUserInfoRes(data) {  
  return {
    type: types.DO_OFFERING_USER_INFO_RES, 
    data
  };
}

export function fetchOfferingUserInfo(userId) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      offeringUserInfoApi.doOfferingUserInfo(userId).then(data => {
        dispatch(doOfferingUserInfoRes(data));
        dispatch(doOfferingUserInfoRes(null));
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}

